import React from 'react';
import { IContent, IProduct } from '../../../types';
import { DoublePushItem } from '../../../types/content';
import { withContent } from '../../../hoc/withContext';
import './PushElement.scss';
import { cleanSpaces, getProductURL, getShopURL, sendEvent } from '../../../utils';

// @ts-ignore
import Fade from 'react-reveal/Fade';

import Image from '../../UI/Image/Image';

interface IPushElementProps {
	context?: IContent;
	info: DoublePushItem;
	index: number;
	product?: IProduct;
}

const PushElement = ({ context, info, index, product }: IPushElementProps) => {
	const { global, config } = context;
	const { cta, description, tracking, image, title } = info;

	const productId = product ? cleanSpaces(info.product.product_id) : null;

	const ctaLink = cta.link && cta.link.indexOf("http") > -1 ? cta.link : cta.link ? getShopURL() + cta.link : null;

	return (
		<div className="element-push">
			<Fade delay={100 * index} duration={600}>
				<div className="block-content">
					<div className="bg-image-desktop">
						{image.desktop && (
							<Image
								imageName={image.desktop}
								altText=""
							/>
						)}
					</div>
					<div className="bg-image-mobile">
						{image.mobile && (
							<Image
								imageName={image.mobile}
								altText=""
							/>
						)}
					</div>
					<div className="content">
						<div className="info">
							{title && <div className="block-title">{title}</div>}
							<div className="description">{description}</div>
							{(product || ctaLink) && (
								<a
									className={`button ${cta.type || "outline"}`}
									href={
										product
											? getProductURL(productId, config.country_code)
											: ctaLink
									}
									target={cta.target}
									onClick={() => sendEvent(tracking)}
									data-alt-text={cta.title || global.play}
								>
									<span>{cta.title || global.play}</span>
								</a>
							)}
						</div>
					</div>
				</div>
			</Fade>
		</div>
	);
};

export default withContent(PushElement);
